"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsVerySmallScreen = exports.useIsSmallScreen = exports.useDeviceStore = exports.DeviceStore = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var DeviceStore = (_class = (_temp = /*#__PURE__*/function () {
  (0, _createClass2["default"])(DeviceStore, [{
    key: "isVeryLargeScreen",
    get: function get() {
      return this.screenInnerWidth >= 1200;
    }
  }, {
    key: "isLargeScreen",
    get: function get() {
      return this.screenInnerWidth >= 900;
    }
  }, {
    key: "isSmallScreen",
    get: function get() {
      return this.screenInnerWidth < 900;
    }
  }, {
    key: "isVerySmallScreen",
    get: function get() {
      return this.screenInnerWidth < 640;
    }
  }, {
    key: "pageGuideX",
    get: function get() {
      return this.isSmallScreen ? "3%" : "15%";
    }
  }, {
    key: "pageGuideXForPageWithTable",
    get: function get() {
      return this.isSmallScreen ? "3%" : "5%";
    }
  }, {
    key: "pageGuideBottom",
    get: function get() {
      return "90px";
    }
  }]);

  function DeviceStore() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, DeviceStore);
    (0, _initializerDefineProperty2["default"])(this, "screenInnerWidth", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "screenInnerHeight", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "pageScrolled", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "pageYOffset", _descriptor4, this);
    window.addEventListener("resize", function () {
      (0, _mobx.runInAction)(function () {
        _this.screenInnerWidth = window.innerWidth;
        _this.screenInnerHeight = window.innerHeight;
      });
    });
    window.addEventListener("scroll", function () {
      (0, _mobx.runInAction)(function () {
        _this.pageYOffset = window.pageYOffset;
        _this.pageScrolled = true;
      });
    });
  }

  (0, _createClass2["default"])(DeviceStore, [{
    key: "screenMatch",
    value: function screenMatch(configs) {
      var verySmallScreen = configs.verySmallScreen,
          smallScreen = configs.smallScreen,
          largeScreen = configs.largeScreen;

      if (this.isVerySmallScreen && verySmallScreen != undefined) {
        return verySmallScreen;
      }

      if (this.isSmallScreen && smallScreen != undefined) {
        return smallScreen;
      }

      return largeScreen || configs["default"];
    }
  }, {
    key: "isFirefox",
    get: function get() {
      return window.navigator.userAgent.toLowerCase().includes("firefox");
    }
  }, {
    key: "isIE",
    get: function get() {
      var ua = window.navigator.userAgent;

      if (ua.includes("MSIE")) {
        return true;
      }

      if (ua.includes("Trident/")) {
        return true;
      }

      if (ua.includes("Edge/")) {
        return true;
      }

      return false;
    }
  }, {
    key: "isiOS",
    get: function get() {
      var ua = window.navigator.userAgent;
      return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    }
  }, {
    key: "isAndroid",
    get: function get() {
      var ua = window.navigator.userAgent; // Windows Phone must come first because its UA also contains "Android"

      return !/windows phone/i.test(ua) && /android/i.test(ua);
    }
  }], [{
    key: "instance",
    value: function instance() {
      var _ref = window,
          deviceStore = _ref.deviceStore;

      if (deviceStore == null) {
        deviceStore = new DeviceStore();
        window.deviceStore = deviceStore;
      }

      return deviceStore;
    }
  }]);
  return DeviceStore;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "screenInnerWidth", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return window.innerWidth;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "screenInnerHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return window.innerHeight;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageScrolled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageYOffset", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return window.pageYOffset;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isVeryLargeScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVeryLargeScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isLargeScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLargeScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isSmallScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSmallScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isVerySmallScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVerySmallScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageGuideX", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageGuideX"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageGuideXForPageWithTable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageGuideXForPageWithTable"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageGuideBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageGuideBottom"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isFirefox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirefox"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isIE", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isIE"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isiOS", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isiOS"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isAndroid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAndroid"), _class.prototype)), _class);
exports.DeviceStore = DeviceStore;

var useDeviceStore = function useDeviceStore() {
  return DeviceStore.instance();
};

exports.useDeviceStore = useDeviceStore;

var useIsSmallScreen = function useIsSmallScreen() {
  var _useDeviceStore = useDeviceStore(),
      isSmallScreen = _useDeviceStore.isSmallScreen;

  return isSmallScreen;
};

exports.useIsSmallScreen = useIsSmallScreen;

var useIsVerySmallScreen = function useIsVerySmallScreen() {
  var _useDeviceStore2 = useDeviceStore(),
      isVerySmallScreen = _useDeviceStore2.isVerySmallScreen;

  return isVerySmallScreen;
};

exports.useIsVerySmallScreen = useIsVerySmallScreen;